import React from 'react'
import {
  faMoneyCheck,
  faObjectGroup,
  faSitemap,
} from '@fortawesome/free-solid-svg-icons'
import StepBar from 'app/common/StepBar'
import {
  getDuplicateOrders,
  mergeDuplicateOrders,
} from 'client/utils/api-routes-orders'
import {
  DcButton,
  PixelCurrency,
  PixelDate,
  PixelFactoryContext,
  PixelTable,
  PixelTag,
  PixelText,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'
import styled from 'styled-components'

import { ButtonContainer, ContainerForPopup } from 'app/common/styles/section'

import { IPixelFactory } from '../../../../decl.d'
import ProductLineItem, {
  Mark,
  MarkSection,
} from '../OrderDetails/components/subComponents/ProductLineItem'
const tenant_info: any = JSON.parse(localStorage.getItem('tenant_info') || '{}')
interface Address {
  first_name: string
  last_name: string
  customer_reference: string
  phone: string
  email: string
  address1: string
  city: string
  country: string
  country_code: string
  state: string
  state_code: string
  postcode: string
}

interface Meta {
  added_by: string
  sale_by_id: string
  sale_by: string
  order_source: string
}

interface Courier {
  courier_name: string
  tracking_id: string
}

interface Payment {
  payment_id: string
  gateway_id: string
  payment_gateway_name: string
  customer_payment_method_id: string | null
  customer_payment_method_name: string | null
  payment_method_type: string | null
  amount: string
  financial_status: string
  created_at: string
  created_by_name: string | null
  name_on_account: string | null
}

interface OrderNote {
  comment_id: string
  order_id: string
  fm_user_id: string
  name: string
  order_comment: string
  comment_type_id: number
  comment_type: string
  comment_time: string
}

interface OrderTag {
  rn: string
  ems_customer_id: string
  order_id: string
  tag_name: string
  date_created: string
  date_updated: string | null
  status: string
  user_id: string | null
}

interface LineItem {
  order_id: number
  quantity: number
  product_id: number
  variation_id: number
  price: number
  total: number
  sku: string
  image: string
  weight: number
  description: string | null
  line_item_id: number
  name: string
  is_partial_return: boolean | null
  has_properties: boolean | null
  fulfillment_order_id: number
  fulfillment_order_line_item_id: number
}

interface OrderHistory {
  order_id: number
  updated_value: string
  change_type: string
  user_name: string
  update_time: string
  is_bulk: boolean
  message: string
}

interface DiscountLine {
  order_discount_line_id: number
  order_id: number
  amount: number
  discount_code: string
}

interface OrderShipping {
  item_id: number
  ems_customer_id: number
  shipping_method_id: number | null
  order_id: number
  method_title: string
  total: number
  tax_on_total: number | null
  is_deleted: boolean | null
}

interface OrderDetails {
  is_billing_address_same: boolean
  customer_id: number
  is_editable: boolean
  shipping: Address
  billing: Address
  total: number
  weight: number
  order_discount: number
  complaint_count: number
  source_order_id: number
  split_source_order_id: string
  store_order_id: number
  store_id: number
  store_name: string
  status: string
  tags: string
  number: number
  created_via: string
  last_comment: string
  date_created: string
  is_refuser: boolean
  is_returning: boolean
  is_duplicate: boolean
  dispatch_id: number
  is_split_child: boolean
  is_split_main: boolean
  split_child_ids: string
  split_main_id: string
  exchanged_from_order_id: string
  print_customer_note_on_shipping_label: boolean
  print_customer_note_on_invoice: boolean
  meta: Meta
  courier: Courier
  payments: Payment[]
  order_notes: OrderNote[]
  order_tags: OrderTag[]
  courier_transactions: any[]
  line_items: LineItem[]
  order_history: OrderHistory[]
  discount_lines: DiscountLine[]
  order_shipping: OrderShipping[]
  order_tax: any[]
  daraz_payment_transactions: any[]
}

interface IProps {
  orderID: number
  details: OrderDetails
  handleClose: (data?: string) => void
}

const MergeOrders = (props: IProps) => {
  const {
    showPageLoader,
    hidePageLoader,
    showSuccess,
    showFailure,
    showWarning,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)
  const { orderID, handleClose, details } = props
  const [data, setData] = React.useState<any>([])
  const [activeStep, setActiveStep] = React.useState({
    step: 'Check Orders',
    mainTitle: 'Possible Duplicate Orders',
  })
  const [selectedOrders, setSelectedOrders] = React.useState<OrderDetails[]>([])
  const [lineItems, setLineItems] = React.useState<LineItem[]>([])
  const Steps = [
    {
      icon: faObjectGroup,
      active: false,
      title: 'Check Orders',
    },
    {
      icon: faSitemap,
      active: false,
      title: 'Check Line Items',
    },
    {
      icon: faMoneyCheck,
      active: false,
      title: 'Check Payment',
    },
  ]
  const backToOrders = () => {
    setActiveStep({
      step: 'Check Orders',
      mainTitle: 'Possible Duplicate Orders',
    })
  }
  const changePage = (action) => {
    switch (activeStep.step) {
      case 'Check Orders':
        action === 'next' && selectedOrders.length > 0
          ? setActiveStep({
              step: 'Check Line Items',
              mainTitle: 'Orders Line Items',
            })
          : showWarning('Please select at least one order')
        break
      case 'Check Line Items':
        action === 'next'
          ? setActiveStep({
              step: 'Check Payment',
              mainTitle: `Order Payments In (${tenant_info.default_currency_symbol})`,
            })
          : backToOrders()
        break
      case 'Check Payment':
        action === 'next'
          ? margeOrders()
          : setActiveStep({
              step: 'Check Line Items',
              mainTitle: 'Orders Line Items',
            })
        break

      default:
        action === 'next' &&
          setActiveStep({
            step: 'Check Line Items',
            mainTitle: 'Orders Line Items',
          })
        break
    }
  }
  const margeOrders = () => {
    const orderIDs = selectedOrders
      .filter((item) => item.number != orderID)
      .map((item) => item.number)
    const data = {
      merge_order_ids: orderIDs,
    }
    showPageLoader()
    mergeDuplicateOrders(orderID, data).subscribe((res: AjaxResponse<any>) => {
      hidePageLoader()
      if (res.response?.data) {
        showSuccess('Orders Merged Successfully')
        showSuccess(res?.response?.message)
        handleClose('success')
      } else {
        showFailure(res?.response?.error)
      }
    })
  }
  const getAllDuplicateOrders = (orderID) => {
    if (orderID) {
      getDuplicateOrders(orderID).subscribe((res: AjaxResponse<any>) => {
        if (res.response?.data.length > 0) {
          if (res.response?.data[0]['error']) {
            showFailure(res.response?.data[0]['error'])
            handleClose()
            return
          }
          setData(res.response?.data)
        } else {
          showFailure('No Duplicate Orders Found')
          handleClose()
        }
      })
    }
  }
  React.useEffect(() => {
    getAllDuplicateOrders(orderID)
  }, [])
  const handleChange = (state) => {
    const mark = 'D'
    let x = 0
    const CurrentSelectedOrders = state.selectedRows
    const select = CurrentSelectedOrders.map((item) => {
      x += 1
      return {
        ...item,
        orderMark: `${mark}${x}`,
      }
    })
    const masterOrder = {
      first_name: details?.billing?.first_name,
      last_name: details?.billing?.last_name,
      number: details?.number,
      dup_id: 0,
      source_order_id: details?.source_order_id,
      duplicate_status: 'new',
      orderMark: 'M',
      status: details?.status,
      city: details?.billing?.city,
      date_created: details?.date_created,
      total: details?.total,
      order_discount: details?.discount_lines
        ?.map((item) => item.amount)
        ?.reduce((a, b) => a + b, 0),
      shipping_fee: details?.order_shipping
        ?.map((item) => item.total)
        ?.reduce((a, b) => a + b, 0),
      line_items: details?.line_items,
    }
    setSelectedOrders([masterOrder, ...select])
    setLineItems([])
    let t = 0
    if (CurrentSelectedOrders.length > 0) {
      let selectedOrdersLineItems: Array<[]> = []
      CurrentSelectedOrders?.map((item) => {
        t += 1
        selectedOrdersLineItems = [
          ...selectedOrdersLineItems,
          ...item.line_items.map((item) => {
            return {
              ...item,
              orderMark: `${mark}${t}`,
            }
          }),
        ]
      })
      const masterLineItems = details?.line_items?.map((item) => {
        return {
          ...item,
          orderMark: 'M',
        }
      })
      setLineItems([...masterLineItems, ...selectedOrdersLineItems])
    }

    const newData = data?.map((item: any) => {
      if (CurrentSelectedOrders?.find((row) => row?.number === item?.number)) {
        item.isSelected = true
      }
      return item
    })
    setData(newData)
  }

  const totalPayments = () => {
    const totalPayments = {
      total: selectedOrders?.reduce((a, b) => a + b.total, 0),
      order_discount: selectedOrders?.reduce((a, b) => a + b.order_discount, 0),
      shipping_fee: selectedOrders?.reduce((a, b) => a + b.shipping_fee, 0),
      lineItems: lineItems?.reduce((a, b) => a + b.total, 0),
    }
    return totalPayments
  }
  const column = [
    {
      dataKey: 'source_order_id',
      name: 'Order Id',
      sortable: true,
      selector: (row) => row.source_order_id,
    },
    {
      dataKey: 'status',
      name: 'Status',
      sortable: true,
      selector: (row) => <PixelTag>{row.status}</PixelTag>,
    },
    {
      dataKey: 'date_created',
      name: 'Date',
      sortable: true,
      selector: (row) => (
        <PixelDate
          className="textSmall"
          value={row.date_created}
          format={'pixelStandard'}
        />
      ),
    },
    {
      dataKey: 'first_name & last_name',
      name: 'Customer Name',
      sortable: true,
      selector: (row) => `${row.first_name} ${row.last_name}`,
    },
    {
      dataKey: 'total',
      name: `Total (${tenant_info.default_currency_symbol})`,
      sortable: true,
      selector: (row) => (
        <PixelCurrency hideSymbol={true} value={row.total}></PixelCurrency>
      ),
    },
  ]
  const paymentColumn = [
    {
      dataKey: 'number',
      name: 'Order',
      sortable: true,
      width: '15%',
      selector: (row) => (
        <MarkSection style={{ width: '100px' }}>
          <Mark>{row.orderMark}</Mark>
        </MarkSection>
      ),
    },
    {
      dataKey: 'order_discount',
      name: 'Discount Line',
      sortable: true,
      selector: (row) => (
        <PixelCurrency
          hideSymbol={true}
          value={row.order_discount}
        ></PixelCurrency>
      ),
    },
    {
      dataKey: 'shipping_fee',
      name: 'Shipping Fee',
      sortable: true,
      selector: (row) => (
        <PixelCurrency
          hideSymbol={true}
          value={row.shipping_fee}
        ></PixelCurrency>
      ),
    },
    {
      dataKey: 'line_items',
      name: 'Line Items Total',
      sortable: true,
      selector: (row) => (
        <PixelCurrency
          hideSymbol={true}
          value={totalLineItemsPayment(row)}
        ></PixelCurrency>
      ),
    },
    {
      dataKey: 'total',
      name: 'Total',
      sortable: true,
      selector: (row) => (
        <PixelCurrency hideSymbol={true} value={row.total}></PixelCurrency>
      ),
    },
  ]
  const totalLineItemsPayment = (row) => {
    const total = row.line_items?.reduce((acc, item) => {
      return acc + item.total
    }, 0)
    return total
  }
  return (
    <div>
      <StepBar Steps={Steps} size={'sm'} activeStep={activeStep.step} />
      <PixelText>
        {activeStep.mainTitle}
        {selectedOrders.length > 0 && (
          <>
            {selectedOrders?.map((item, index) => {
              return (
                <MarkSection key={index} className="textSmall">
                  <Mark className="textSmall">{item.orderMark}</Mark>
                  <div
                    style={{
                      display: 'flex',
                    }}
                  >
                    {item.orderMark === 'M'
                      ? `Main Order(${item.number})`
                      : `Duplicate order(${item.number})`}
                  </div>
                </MarkSection>
              )
            })}
          </>
        )}
      </PixelText>
      <Container>
        {(() => {
          switch (activeStep.step) {
            case 'Check Orders':
              return (
                <ContainerForPopup>
                  <PixelTable
                    selectableRows
                    data={data}
                    columns={column}
                    pagination={false}
                    onSelectedRowsChange={handleChange}
                    fixedHeader
                    fixedHeaderScrollHeight="calc(100vh - 330px)"
                  />
                </ContainerForPopup>
              )
            case 'Check Line Items':
              return (
                <ContainerForPopup>
                  <TableHeader>
                    <HeaderTitle width={'8%'}>Order</HeaderTitle>
                    <HeaderTitle width={'8%'}>Image</HeaderTitle>
                    <HeaderTitle width={'44%'}>Product Name</HeaderTitle>
                    <HeaderTitle width={'15%'}>Qty</HeaderTitle>
                    <HeaderTitle width={'15%'}>Price</HeaderTitle>
                    <HeaderTitle width={'10%'}>Total</HeaderTitle>
                  </TableHeader>
                  {lineItems?.map((item, index) => {
                    return (
                      <ProductLineItem
                        size={'sm'}
                        item={item}
                        key={index}
                        showOrderMark={true}
                      />
                    )
                  })}
                </ContainerForPopup>
              )
            case 'Check Payment':
              return (
                <ContainerForPopup>
                  <PixelTable
                    data={selectedOrders}
                    columns={paymentColumn}
                    pagination={false}
                    fixedHeader
                    fixedHeaderScrollHeight="calc(100vh - 330px)"
                  />
                  <Total>
                    <TotalAM width={'18%'}>Total Amounts</TotalAM>
                    <TotalAM width={'20%'}>
                      <PixelCurrency
                        hideSymbol={true}
                        value={totalPayments().order_discount}
                      />
                    </TotalAM>
                    <TotalAM width={'22%'}>
                      <PixelCurrency
                        hideSymbol={true}
                        value={totalPayments().shipping_fee}
                      />
                    </TotalAM>
                    <TotalAM width={'20%'}>
                      <PixelCurrency
                        hideSymbol={true}
                        value={totalPayments().lineItems}
                      />
                    </TotalAM>
                    <TotalAM width={'18%'}>
                      <PixelCurrency
                        hideSymbol={true}
                        value={totalPayments().total}
                      />
                    </TotalAM>
                  </Total>
                </ContainerForPopup>
              )
            default:
              return <ContainerForPopup>Merge Orders</ContainerForPopup>
          }
        })()}
      </Container>
      <ButtonContainer>
        {activeStep.step !== 'Check Orders' && (
          <DcButton
            size={'sm'}
            variant={'outline-secondary'}
            onClick={() => {
              changePage('prev')
            }}
          >
            Previous
          </DcButton>
        )}
        <DcButton
          size={'sm'}
          variant={'outline-secondary'}
          onClick={() => {
            if (selectedOrders.length > 6) {
              showFailure('You can not merge more than 5 orders at a time')
            } else {
              changePage('next')
            }
          }}
        >
          {activeStep.step === 'Check Payment' ? 'Merge' : 'Next'}
        </DcButton>
      </ButtonContainer>
    </div>
  )
}
const Container = styled.div``

const TableHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e6e6e6;
  background-color: rgba(1, 104, 249, 0.07);
`
const Total = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-top: 1px solid #e6e6e6;
  font-size: 13px;
  font-weight: 600;
  padding: 11px 0px;
  background-color: #efefef;
`
const HeaderTitle = styled.div<{ width?: string }>`
  width: ${(props) => props.width};
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.84);
  padding: 10px;
`
const TotalAM = styled.div<{ width: string }>`
  width: ${(props) => props.width};
`
export {
  MergeOrders,
  ButtonContainer,
  TableHeader,
  Total,
  HeaderTitle,
  TotalAM,
}
